import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

import {environment} from '../../../environments/environment';
import {AuthBody} from '../model/authBody';
import {AuthResponse} from '../model/authResponse';
import {ErrorResponse} from '../model/errorResponse';
import {Module} from '../model/module';
import {ModuleVisibility} from '../model/moduleVisibility';
import {User} from '../model/user';
import {SessionService} from './session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class ModulesService {
  constructor(private http: Http, private sessionService: SessionService) {}

  public getModuleById(id: string): Observable<Module> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });
    return this.http.get(API_URL + '/v1/trainings/' + id, headers)
        .map(response => {
          return new Module(response.json());
        })
        .catch(this.handleError.bind(this)) as Observable<Module>;
  }

  public getAllModules(): Observable<Module[]> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http.get(API_URL + '/v1/trainings', headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public createModulewithObject(
      name: string, image_url: string, tincan_url: string,
      visibility: ModuleVisibility[], isExam: boolean): Observable<Module> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {
      'name': name,
      'image_url': image_url,
      'tincan_url': tincan_url,
      'visibility': visibility,
      'is_exam': isExam
    };

    return this.http
        .post(API_URL + '/v1/trainings', JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public updateModule(module: Module): Observable<Module> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {
      _id: module._id,
      name: module.name,
      tincan_url: module.tincan_url,
      is_exam: module.is_exam,
      image_url: module.image_url
    };

    return this.http
        .put(API_URL + '/v1/trainings/' + module._id, JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public updateOrder(id: string, order: number): Observable<Module> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {'order': order};

    return this.http
        .put(API_URL + '/v1/trainings/' + id, JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public updateModuleVisability(id: string, moduleVisability: ModuleVisibility):
      Observable<Module> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {'visibility': moduleVisability};

    return this.http
        .put(API_URL + '/v1/trainings/' + id, JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public deleteModule(id: string): Observable<Module> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http.delete(API_URL + '/v1/trainings/' + id, headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }


  private handleError(error: Response|any) {
    console.log(error);
    return this.sessionService.handleAuthenticatedRequestError(error);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/modules.service.ts